import { ManagerProfile } from '../../domain/ManagerProfile';

abstract class ManagerProfileRepository {
  abstract getMyProfile(): Promise<ManagerProfile>;
}

export default ManagerProfileRepository;
